import { createContext, useEffect, useState } from 'react';
import { responsiveLimit } from './../constants/styles';

const ResponsiveContext = createContext<boolean | null>(null);

export function ResponsiveContextProvider({ children }: any) {
    let [responsive, setResponsive] = useState<boolean>(
        responsiveLimit < window.innerWidth
    );

    const setResponsiveContext = () => {
        setResponsive(responsiveLimit < window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener('resize', setResponsiveContext);
        return () => {
            window.removeEventListener('resize', setResponsiveContext);
        };
    }, []);

    return (
        <ResponsiveContext.Provider value={responsive}>
            {children}
        </ResponsiveContext.Provider>
    );
}

export function ResponsiveContextConsumer({ children }: any) {
    return <ResponsiveContext.Consumer>{children}</ResponsiveContext.Consumer>;
}
